/**
 * @author xyguo
 * @description 角色管理==》人员维护==》添加人员管理页面,可在该角色下添加人员
 * @Date 2020/1/2
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool} from '@/tool'
import 'antd/dist/antd.css';
import {Button} from 'antd';

let {WizContainer, modelUtils} = framework_tool;
let {WizForm, WizSelect} = component_tool;


class BatchInput extends WizContainer {
  componentName = "BatchInput";

  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      ids: []
    };
    this.initTargetKeys = [];
    this.initTargetRows = [];
    this.values = {};
    this.leaveStateStudents = []; //请假的学员
  }

  _componentWillMount() {
    let {initRows} = this.props;
    if (initRows && initRows()) {
      this.state.selectedRows = initRows();
      this.initTargetRows = initRows();
      initRows().forEach(data => {
        this.state.ids.push(data.id);
        this.initTargetKeys.push(data.id);
        if(data.leaveState){
          this.leaveStateStudents.push(data);
        }
      })
    }
  }

  getSelectRows = (e) => {
    this.state.selectedRows = e;
    this.initTargetRows = e;
    this.state.ids = [];
    e.forEach(data => {
      this.state.ids.push(data.id);
      this.initTargetKeys.push(data.id);
      if(data.leaveState){
        this.leaveStateStudents.push(data);
      }
    })
  };

  /**
   * modal框的确定按钮触发
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = () => {
    this.ref.validateFields((err, values) => {
      this.values = values;
      if (this.state.ids.length === 0 && !this.props.alone) {
        wizNotice.error("请选择学员");
      } else if (values['status']==3 && (values['score'] != undefined || values['score'] != null)){
        wizNotice.error("无成绩状态,分数只能为空");
      }
      // else if (values['status']!=3 && (values['score'] == undefined || values['score'] == null)){
      //   wizNotice.error("不是无成绩状态,分数不能为空");
      // }
      else if (!err) {
        let flag = false; //是否包含请假的学员
        let userName = null; //请假的学员账号
		let fullName =null;//请假的学员姓名
      if (this.leaveStateStudents && this.leaveStateStudents.length>0 && !this.props.alone){
           this.state.ids.forEach(id=>{
            this.leaveStateStudents.forEach(e=>{
              if(e.id===id){
                flag = true;
                userName = e.userName;
                fullName = e.fullName;
                return ;
              }
            })
          })
        }
        if(flag){
          wizNotice.error("学员:"+fullName+ " 是请假状态,不可输入成绩,请确认后重试!");
        }else{
          this._saveClassResult(values);
        }
      }
      return
    });
  };

  /**
   * 初始化已选人员
   */
  _doInitParams = () => {
    this.onChange(this.initTargetKeys, this.initTargetRows)
  };

  onChange = (nextTargetKeys, nextTargetRows) => {
    this.setState({
      ids: nextTargetKeys,
      selectedRows: nextTargetRows
    });
  };

  propsAndStateOnChange = {
    batchUpdate: this._batchUpdate.bind(this),
  };

  _batchUpdate(nextProps, nextState) {
    if (nextProps.batchUpdate.code === 1) {
      wizNotice.success("操作成功");
      this.doAction({
        path: `classResult/getListInfo`,
        payload: {
          key: `classResult@getListInfo`,
          apiParams: {classInfoId:this.props.classInfoId} 
        }
      });
      this.props.changeModal(false, true);
      this.onChange(this.initTargetKeys, this.initTargetRows);
    } else {
      wizNotice.error(nextProps.batchUpdate.msg);
    }

  }

  /**
   * 更新 班级学员成绩
   * @param values
   * @private
   */
  _saveClassResult(values) {   
    let personIds=[];
    if(!this.props.personId){
        for (let index = 0; index < this.state.selectedRows.length ; index++) {
          personIds.push(this.state.selectedRows[index].personId);
        }
    }else{
      personIds.push(this.props.personId)
    }
    
    let apiPath = "classResult/batchUpdate";
    let payloadKey = "classResult@batchUpdate";
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...values,
          ids: this.props.alone ? [this.props.record.id] :this.state.ids,classInfoId:this.props.classInfoId,personIds:personIds
        }
      }
    });
  }  

  handleClear(id) {
    id
      ? this.setState({
        selectedRows: this.state.selectedRows.filter(item => item.id !== id),
        ids: this.state.ids.filter(item => item !== id)
      })
      : this.setState({
        selectedRows: [],
        ids: []
      });
  }

  //select中的change事件
  _wizSelectOnChange(value, option) {
    //
    let classify = value.map(select => select.key)
    let selectedRows = this.state.selectedRows.filter(filter => classify.indexOf(filter.key) !== -1)
    const selectIds = [];
    selectedRows.forEach(data => {
      selectIds.push(data.id)
    })
    this.setState({
      selectedRows: selectedRows,
      ids: selectIds
    });
  }

  _renderOptions(selectedRows) {
    if (selectedRows && selectedRows.length) {
      return selectedRows.map((row, i) => this._renderOption(row))
    }
    return null
  }

  _renderOption(row) {
    if (row) {
      const fullName = row.fullName;
      return (
        <WizSelect.Option key={row.id} value={fullName} title={fullName}>
          {fullName}
        </WizSelect.Option>
      )
    }
  }

  _render() {
    const {classResultLoading, record} = this.props;
    const ids = this.state.ids;
    let columns = [
      {
        name: "ids",
        formItem: {
          type: 'hidden',
          initialValue: {ids}
        },
      },
      this.props.alone ?
      {
        title: "账号",
        name: "userName",
        formItem: {
          initialValue: record.userName,
          disabled:true
        }
      }
      : {}
      ,
      this.props.alone ? {
        title: "姓名",
        name: "fullName",
        formItem: {
          initialValue: record.fullName,
          disabled:true
        }
      }
      : {}
      ,
      {
        title: "成绩",
        name: "score",
        formItem: {
          type: 'number',
          placeholder: '请输入成绩',
          col: { span: 12},
          formItemLayout: {
            labelCol: {span: 6},
            wrapperCol: {span: 18}
          },
          min:0,
          max:9999,
          maxlength: 10,
          rules: [ {
            pattern: /^(0\.?\d{0,2}|[1-9]\d*\.?\d{0,2})$/,
            message: '请输入大于等于0的最多两位小数的成绩'
          }],
          initialValue: this.props.alone && record.status!=3 ? record.score : undefined,

        },
      },
      {
        title: "通过状态",
        name: "status",
        dict: [
          {code: 1, codeName: "通过"},
          {code: 2, codeName: "未通过"},
          {code: 3, codeName: "无成绩"}
        ],
        formItem: {
          type: "select",
          col: { span: 12},
          formItemLayout: {
            labelCol: {span: 8},
            wrapperCol: {span: 16}
          },
          rules: [{
            required: true,
            message: '请选择通过状态',
          }],
          initialValue: this.props.alone && record.status!=0 ? record.status : '',
          onSelect: value => {
            if(value === 3 ){
              this.ref.setFieldsValue({score: undefined})
            }
          }
        },
      },
      {
        title: "考勤状态",
        name: "attendanceState",
        dict: [
          {code: 1, codeName: "请假"},
          {code: 2, codeName: "全勤"},
          {code: 3, codeName: "缺勤"}
        ],
        formItem: {
          type: "select",
          rules: [{
            required: true,
            message: '请选择考勤状态',
          }],
          initialValue: this.props.alone && [undefined, null, -1, 0].indexOf(record?.attendanceState) === -1 ? record.attendanceState : 2,
        },
      },
      {
        title: "评语",
        name: "comment",
        formItem: {
          type: 'textarea',
          placeholder: '请输入评语最多输入100个字符',
          maxlength: 100,
          rules: [],
          initialValue: this.props.alone ? record.comment : ''
        },
      }
    ];

    let onSubmit = this._saveClassResult.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: <div/>,
      formItemLayout: {
        labelCol: {span: 3},
        wrapperCol: {span: 21}
      },
      style: {maxWidth: 800}
    };
    let selectKey = this.state.selectedRows.map(selected => selected.id).join(",");
    const selectedRows = this.state.selectedRows;
    selectedRows.forEach(data => {
      data.key = data.id,
        data.label = data.fullName
    });
    const header = (
      <div style={{paddingLeft: 15, paddingBottom: 12}}>
        已选人员<strong> {selectedRows.length} </strong> {'人'}
        <Button type="link" onClick={() => this.handleClear()}>清除选择</Button>
      </div>
    );

    return (
      <div>
        
        { !this.props.alone ? <>{header} <WizSelect
          style={{width: '100%', height: 80, paddingLeft: 15}}
          key={'wizSelect_' + selectKey}
          defaultValue={this.state.selectedRows}
          labelInValue
          mode={'multiple'}
          open={false}
          onChange={(value, option) => this._wizSelectOnChange(value, option)}
        >
          {this._renderOptions(selectedRows)}
        </WizSelect></> :  <></>}
        <WizForm  {...formProps} ref={r => {
          this.ref = r;
        }}/>
      </div>
    )
  }
}


const mapStateToProps = (state, ownProps) => {
  const {classResult} = state;
  const batchUpdate = modelUtils.getModelEntity(classResult, 'classResult@batchUpdate');
  return {
    batchUpdate: batchUpdate,
  };
};

const options = {withRef: true};

export default connect(mapStateToProps, null, null, options)(BatchInput);
